import { Loader } from '@mantine/core';

export const PageLoading = () => (
  <div
    style={{
      height: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    <Loader type='oval' />
  </div>
);
